import { render, staticRenderFns } from "./syncDialogs.vue?vue&type=template&id=fe9b068a&"
import script from "./syncDialogs.vue?vue&type=script&lang=js&"
export * from "./syncDialogs.vue?vue&type=script&lang=js&"
import style0 from "./syncDialogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports